import React from 'react'

import { Button, DiscountGradient } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import i18n from 'Pods/Shared/I18n'

import { NOOP } from 'Utils/stableDefaults'

const SUBSCRIPTION_PATH = '/subscription'

function PromoPanel({ onCtaClick = NOOP }) {
  const translate = (key) => i18n.t(`listingPage.upsellBlock.${key}`, { ns: 'rails' })

  return (
    <div className="upsell-block__promo-inner">
      <div className="upsell-block__promo-label">
        <DiscountGradient className="upsell-block__promo-label-icon" />
        <span className="upsell-block__promo-label-text">{translate('label')}</span>
      </div>
      <div className="upsell-block__promo-text">
        <h3 className="upsell-block__promo-heading cgt-heading-300">
          {translate('heading')}
        </h3>
        <p className="upsell-block__promo-body cgt-body-base-semibold">{translate('body')}</p>
      </div>
      <Button
        href={SUBSCRIPTION_PATH}
        type="primary"
        size="small"
        customClass="upsell-block__promo-cta upsell-block__promo-cta--stretched"
        onClick={onCtaClick}
        data-subscription-entry={SubscriptionEntryPoints.LISTING_FREE_FILTER_UPSELL}
      >
        {translate('cta')}
      </Button>
    </div>
  )
}

PromoPanel.propTypes = {
  onCtaClick: func,
}

export default PromoPanel
